import type { Alpha2Code } from 'i18n-iso-countries';

export type ApiCountryCode = 'AF'
	| 'AL'
	| 'DZ'
	| 'AS'
	| 'AD'
	| 'AG'
	| 'AI'
	| 'AR'
	| 'AA'
	| 'AW'
	| 'AU'
	| 'AT'
	| 'AZ'
	| 'BS'
	| 'BH'
	| 'BD'
	| 'BB'
	| 'BY'
	| 'BE'
	| 'BZ'
	| 'BJ'
	| 'BM'
	| 'BT'
	| 'BO'
	| 'BL'
	| 'BA'
	| 'BW'
	| 'BR'
	| 'BC'
	| 'BN'
	| 'BG'
	| 'BF'
	| 'BI'
	| 'KH'
	| 'CM'
	| 'CA'
	| 'IC'
	| 'CV'
	| 'KY'
	| 'CF'
	| 'TD'
	| 'CD'
	| 'CL'
	| 'CN'
	| 'CI'
	| 'CS'
	| 'CO'
	| 'CC'
	| 'CG'
	| 'CK'
	| 'CR'
	| 'CT'
	| 'HR'
	| 'CU'
	| 'CB'
	| 'CY'
	| 'CZ'
	| 'DK'
	| 'DJ'
	| 'DM'
	| 'DO'
	| 'TM'
	| 'EC'
	| 'EG'
	| 'SV'
	| 'GQ'
	| 'ER'
	| 'EE'
	| 'ET'
	| 'FA'
	| 'FO'
	| 'FJ'
	| 'FI'
	| 'FR'
	| 'GF'
	| 'PF'
	| 'FS'
	| 'GA'
	| 'GM'
	| 'GE'
	| 'DE'
	| 'GH'
	| 'GI'
	| 'GR'
	| 'GL'
	| 'GD'
	| 'GP'
	| 'GU'
	| 'GT'
	| 'GN'
	| 'GY'
	| 'HT'
	| 'HW'
	| 'HN'
	| 'HK'
	| 'HU'
	| 'IS'
	| 'IN'
	| 'ID'
	| 'IA'
	| 'IQ'
	| 'IR'
	| 'IM'
	| 'IL'
	| 'IT'
	| 'JM'
	| 'JP'
	| 'JO'
	| 'KZ'
	| 'KE'
	| 'KI'
	| 'NK'
	| 'KS'
	| 'KW'
	| 'KG'
	| 'LA'
	| 'LV'
	| 'LB'
	| 'LS'
	| 'LR'
	| 'LY'
	| 'LI'
	| 'LT'
	| 'LU'
	| 'MO'
	| 'MK'
	| 'MG'
	| 'MY'
	| 'MW'
	| 'MV'
	| 'ML'
	| 'MT'
	| 'MH'
	| 'MQ'
	| 'MR'
	| 'MU'
	| 'ME'
	| 'MX'
	| 'MI'
	| 'MD'
	| 'MC'
	| 'MN'
	| 'MS'
	| 'MA'
	| 'MZ'
	| 'MM'
	| 'NA'
	| 'NU'
	| 'NP'
	| 'AN'
	| 'NL'
	| 'NV'
	| 'NC'
	| 'NZ'
	| 'NI'
	| 'NE'
	| 'NG'
	| 'NW'
	| 'NF'
	| 'NO'
	| 'OM'
	| 'PK'
	| 'PW'
	| 'PS'
	| 'PA'
	| 'PG'
	| 'PY'
	| 'PE'
	| 'PH'
	| 'PO'
	| 'PL'
	| 'PT'
	| 'PR'
	| 'QA'
	| 'RS'
	| 'RE'
	| 'RO'
	| 'RU'
	| 'RW'
	| 'NT'
	| 'EU'
	| 'HE'
	| 'KN'
	| 'LC'
	| 'MB'
	| 'PM'
	| 'VC'
	| 'SP'
	| 'SO'
	| 'SM'
	| 'ST'
	| 'SA'
	| 'SN'
	| 'SC'
	| 'SL'
	| 'SG'
	| 'SK'
	| 'SI'
	| 'SB'
	| 'OI'
	| 'ZA'
	| 'ES'
	| 'LK'
	| 'SD'
	| 'SR'
	| 'SZ'
	| 'SE'
	| 'CH'
	| 'SY'
	| 'TA'
	| 'TW'
	| 'TJ'
	| 'TZ'
	| 'TH'
	| 'TG'
	| 'TK'
	| 'TO'
	| 'TT'
	| 'TN'
	| 'TR'
	| 'TU'
	| 'TC'
	| 'TV'
	| 'UG'
	| 'UA'
	| 'AE'
	| 'GB'
	| 'US'
	| 'UY'
	| 'UZ'
	| 'VU'
	| 'VS'
	| 'VE'
	| 'VN'
	| 'VB'
	| 'VA'
	| 'WK'
	| 'WF'
	| 'YE'
	| 'ZR'
	| 'ZM'
	| 'ZW';

/**
 * In der v1 werden noch alte oder teilweise falsche Ländercodes verwendet.
 * Damit das alte System trotzdem funktioniert, ohne geändert zu werden,
 * gibt es hier eine Mapping Tabelle auf die offiziellen ISO Codes
 */
export const apiCountryToIsoMapping: Partial<Record<ApiCountryCode, Alpha2Code>> = {
	// Ungültiger Code 'AA' wurde für Armenien ('AM') verwendet.
	AA: 'AM',

	// Inkorrekte Zuordnung: 'AG' ist Antigua & Barbuda, wurde für Angola ('AO') verwendet.
	AG: 'AO',

	// Inoffizieller Code für British Indian Ocean Ter ('IO').
	BC: 'IO',

	// 'BL' ist St. Barthélemy. Code wurde für Bonaire verwendet, das zu 'BQ' gehört.
	BL: 'BQ',

	// Falsche Zuordnung: 'CB' inoffiziell, Curacao ist 'CW'.
	CB: 'CW',

	// Falsche Zuordnung: 'CD' ist DR Kongo, wurde für Channel Islands verwendet. Die Inseln sind 'JE'/'GG'.
	CD: 'JE',

	// Falsche Zuordnung: 'CI' ist Côte d'Ivoire, wurde für Christmas Island ('CX') verwendet.
	CI: 'CX',

	// Falsche Zuordnung: 'CS' war Serbien/Montenegro, wurde für Cocos Island ('CC') verwendet.
	CS: 'CC',

	// Inoffizieller Code 'CT' wurde für Côte d'Ivoire ('CI') verwendet.
	CT: 'CI',

	// Inoffizieller Code 'FA' wurde für Falkland Islands ('FK') verwendet.
	FA: 'FK',

	// Inoffizieller Code 'FS' wurde für French Southern Ter ('TF') verwendet.
	FS: 'TF',

	// Hawaii ist ein Bundesstaat der USA ('US'). Inoffizieller Code 'HW'.
	HW: 'US',

	// Inoffizieller Code 'IA' wurde für Iran verwendet. Iran ist 'IR'.
	IA: 'IR',

	// Die Kanarischen Inseln ('IC') sind Teil von Spanien ('ES').
	IC: 'ES',

	// Falsche Zuordnung: 'IR' ist Iran, wurde für Ireland ('IE') verwendet.
	IR: 'IE',

	// Südkorea ist 'KR', alter Code war 'KS'.
	KS: 'KR',

	// Falsche Zuordnung: 'ME' ist Montenegro, wurde für Mayotte ('YT') verwendet.
	ME: 'YT',

	// Midway Islands ('MI') sind Teil der US Minor Outlying Islands ('UM').
	MI: 'UM',

	// In Liste 1 falsch geschrieben als "Nambia", korrekt ist Namibia ('NA'). Code war schon 'NA'.
	// 'NA': 'NA',

	// Nordkorea ist 'KP', alter Code war 'NK'.
	NK: 'KP',

	// Niederländische Antillen ('AN') sind historisch, jetzt 'BQ', 'CW', 'SX'.
	AN: 'BQ',

	// Nevis ('NV') gehört zu St. Kitts und Nevis ('KN'). Inoffizieller Code.
	NV: 'KN',

	// Niue ist 'NU', inoffizieller Code 'NW'.
	NW: 'NU',

	// Inoffizieller Code 'OI' wurde für Somalia ('SO') verwendet.
	OI: 'SO',

	// Inoffizieller Code 'PO' wurde für Pitcairn Island ('PN') verwendet.
	PO: 'PN',

	// 'NT' (historisch) wurde für St Barthelemy ('BL') verwendet.
	NT: 'BL',

	// 'EU' (reserviert) wurde für St Eustatius verwendet, das zu 'BQ' gehört.
	EU: 'BQ',

	// 'HE' (inoffiziell) wurde für St Helena verwendet, das zu 'SH' gehört.
	HE: 'SH',

	// 'MB' (inoffiziell) wurde für St Maarten (niederländ. Teil) verwendet, das 'SX' ist.
	MB: 'SX',

	// Saipan ('SP') gehört zu den Nördlichen Marianen ('MP').
	SP: 'MP',

	// Falsche Zuordnung: 'SO' ist Somalia, wurde für Samoa ('WS') verwendet.
	SO: 'WS',

	// Tahiti ist Teil von Französisch-Polynesien ('PF'). Code 'TA' inoffiziell.
	TA: 'PF',

	// Falsche Zuordnung: 'TM' ist Turkmenistan, wurde für East Timor ('TL') verwendet.
	TM: 'TL',

	// Falsche Zuordnung: 'TU' ist inoffiziell, wurde für Turkmenistan ('TM') verwendet.
	TU: 'TM',

	// 'VB' (inoffiziell) wurde für Virgin Islands (Brit) verwendet, das 'VG' ist.
	VB: 'VG',

	// Falsche Zuordnung: 'VA' ist Vatikanstadt, wurde für Virgin Islands (USA) verwendet, das 'VI' ist.
	VA: 'VI',

	// Falsche Zuordnung: 'VS' (inoffiziell) wurde für Vatican City State verwendet, das 'VA' ist.
	VS: 'VA',

	// Wake Island ('WK') ist Teil der US Minor Outlying Islands ('UM').
	WK: 'UM',

	// 'ZR' (historisch) war Zaire, jetzt Demokratische Republik Kongo ('CD').
	ZR: 'CD',
};

export const ensureCountryIsoCode = (input: string): Alpha2Code => {
	return apiCountryToIsoMapping[input as ApiCountryCode] ?? input as Alpha2Code;
};

export const ensureApiCountryCode = (input: string): ApiCountryCode => Object
	.entries(apiCountryToIsoMapping)
	.find(([, isoCode]) => input === isoCode)?.[0] as ApiCountryCode ?? input;
